/**
 * Insurance utility functions
 * 
 * Centralizes insurance-related checks and validations
 */

/**
 * Checks if the user has selected self-pay insurance options
 * @param insurance - The insurance value from state (can be null, undefined, or string)
 * @returns true if the user selected self-pay, false otherwise
 */
export function isSelfPay(insurance: string | null | undefined): boolean {
  if (!insurance) return false;
  return insurance === 'I will Self Pay' || insurance === 'Self Pay';
}

/**
 * Checks if the user has insurance (not self-pay)
 * @param insurance - The insurance value from state (can be null, undefined, or string)
 * @returns true if the user has insurance (not self-pay), false otherwise
 */
export function hasInsurance(insurance: string | null | undefined): boolean {
  if (!insurance) return false;
  return !isSelfPay(insurance);
}

